

<div class="signuplogin " [ngClass]="{'mt-0': IsAdminLogin}">
  <nav class="navbar" *ngIf="IsAdminLogin ">
    <!-- <div id="mySidebar" class="sidebar" *ngIf="!IsAdminLogin ">
      <a class="margintp pt-0 handsymbol" (click)="closeNav()"
        ><img src="assets/images/close.svg" width="18" class="pt-1"
      /></a>
      <a
        class="optn handsymbol"
        href="{{aap_url}}"
        href="javascript:void(0)"
        ><span>Home</span>
        <img src="assets/images/home-rq.svg" class="pt-1 float-right optn"
      /></a>
      <a
        class="optn handsymbol"
        
        href="{{aap_url}}/faq"
       
        ><span>FAQ</span>
        <img src="assets/images/faq-re.svg" class="pt-1 float-right"
      /></a>
      <a class="optn handsymbol" href="{{aap_url}}/blog"
        ><span>Blog</span>
        <img src="assets/images/blog-re.svg" class="pt-1 pr-1 float-right"
      /></a>
      <a
        class="optn handsymbol pr-2"
        href="{{aap_url}}/giveback"
        ><span>Giveback</span>
        <img src="assets/images/giveback-re.svg" class="pt-1 pr-1 float-right"
      /></a>
      <a
        class="optn handsymbol"
        
        (click)="headerMenu('startover')"
        >Start Over
        <img src="assets/images/startover-re.svg" class="pt-1 float-right"
      /></a>
      <a class="optn handsymbol" 
      href="{{aap_url}}/faq/contact-us"
        >Contact Us
        <img src="assets/images/contactus-re.svg" class="pt-2 float-right"
      /></a>

      <a
        class="optn handsymbol"
        *ngIf="showLogin"
        (click)="headerMenu('user-settings')"
        >Profile
        <img
          src="assets/images/profile-icon-lightgray.svg"
          class="pt-2 float-right"
      /></a>

   

      <a
        class="optn handsymbol"
        *ngIf="showLogin"
        (click)="headerMenu('logout')"
        >Logout
        <img
          src="assets/images/logout-icon-lightgray.svg"
          class="pt-2 float-right"
      /></a>

      <div class="sidebar-ftr">
        <ul class="list-inline mb-5">
          <li>
            <a href="https://www.facebook.com/honestgorilla1/" target="_blank"
              ><img src="assets/images/facebook.svg" width="30"
            /></a>
          </li>
          <li>
            <a href="https://twitter.com/honestgorilla" target="_blank"
              ><img src="assets/images/twitter.svg" width="30"
            /></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/honestgorilla_energy/ "
              target="_blank"
              ><img src="assets/images/instragram.svg" width="30"
            /></a>
          </li>
        </ul>
      </div>
    </div> -->
    <div id="mySidebar" class="sidebar" *ngIf="IsAdminLogin ">
      <a class="margintp pt-0 handsymbol" (click)="closeNav()"
        ><img src="assets/images/close.svg" width="18" class="pt-1"
      /></a>
      <a
        class="optn handsymbol"
        (click)="Redirect('hg-admin-success')"
        href="javascript:void(0)"
        ><span>Dashboard</span>
        <img src="assets/images/home-rq.svg" class="pt-1 float-right optn"
      /></a>
      <a
        class="optn handsymbol"
        
        (click)="Redirect('hg-admin-affiliate-list')"
        href="javascript:void(0)"
       
        ><span>Affiliates</span>
        <img src="assets/images/link-icon.svg" width="33" class="pt-1 float-right"
      /></a>
      <a class="optn handsymbol" 
      (click)="Redirect('hg-admin-promocode-list')"
        href="javascript:void(0)"
        ><span>Promo codes</span>
        <img src="assets/images/promoicon.png" width="33" height="33" style="opacity: 0.8;" class="pt-1 pr-1 float-right"
      /></a>
      <a class="optn handsymbol" 
      (click)="Redirect('hg-admin-zipcode-list')"
        href="javascript:void(0)"
        ><span>Zip codes</span>
        <img src="assets/images/location-dot-solid.svg" width="33" height="33" style="opacity: 0.8;" class="pt-1 pr-1 float-right"
      />
   </a>
      

      <a
        class="optn handsymbol"
        *ngIf="showLogin"
        (click)="headerMenu('logout')"
        >Logout
        <img
          src="assets/images/logout-icon-lightgray.svg"
          class="pt-2 float-right" style="    right: 15px;"
      /></a>

      <div class="sidebar-ftr">
        <ul class="list-inline mb-5">
          <li>
            <a href="https://www.facebook.com/honestgorilla1/" target="_blank"
              ><img src="assets/images/facebook.svg" width="30"
            /></a>
          </li>
          <li>
            <a href="https://twitter.com/honestgorilla" target="_blank"
              ><img src="assets/images/twitter.svg" width="30"
            /></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/honestgorilla_energy/ "
              target="_blank"
              ><img src="assets/images/instragram.svg" width="30"
            /></a>
          </li>
        </ul>
      </div>
    </div>
    <div id="main" class="w-100" *ngIf="IsAdminLogin ">
      <button
        *ngIf="menuIconShow && showheader != 'true'"
        class="openbtn"
        id="hideprocess"
        (click)="openNav($event)"
      >
        <img src="assets/images/list.png" width="15" />
      </button>
      <a
        class="navbar-brand logomain mt-2"
        id="hidetxt"
        (click)="openNav($event)"
        ><img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg"
          alt="Honest Gorilla logo in pink"
          title="Pink Honest Gorilla logo"
          height="33"
          class="logo ml-3 logotextClick"
          style="cursor: pointer" /><img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg"
          alt="Honest Gorilla logo in pink"
          title="Pink Honest Gorilla logo"
          width="150"
          class="logo1 sectpad logotextClick"
      /></a>
      <a
        *ngIf="iconshow && showheader != 'true'"
        class="float-right text-center ml-1 mt-1 wd60 webview handsymbol"
        data-toggle="modal"
        data-target="#contactModal"
        (click)="showModal()"
        ><img src="assets/images/help.png" />
        <font class="disblk clr333 quesnavtxt handsymbol">Help</font>
      </a>
      <a
        *ngIf="iconshow && showheader != 'true'"
        class="float-right text-center ml-1 mt-1 wd60 webview handsymbol startoverclass"
        (click)="startOver()"
        ><img src="assets/images/startovergry.png" />
        <font class="disblk clr333 quesnavtxt handsymbol">Start Over</font>
      </a>
    </div>
  
  </nav>
  <app-contactus
    [mVisible]="modalVisible"
    (closeModalEvent)="onClose($event)"
  ></app-contactus>

  <div id="main" class="w-100" *ngIf="!iconshow && menuIconShow && showheader != 'true' && !IsAdminLogin">
    <header class="newhearder-fixed elementor-section elementor-top-section elementor-element elementor-element-4fbb326 elementor-section-height-min-height elementor-reverse-mobile elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-items-middle elementor-sticky elementor-sticky--active elementor-section--handles-inside" data-id="4fbb326" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;sticky&quot;:&quot;top&quot;,&quot;sticky_on&quot;:[&quot;desktop&quot;],&quot;sticky_effects_offset&quot;:80,&quot;sticky_offset&quot;:0}" >
      <div class="elementor-container elementor-column-gap-no">
    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3d93f29" data-id="3d93f29" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
      <div class="elementor-element elementor-element-2a9644b elementor-widget elementor-widget-image" data-id="2a9644b" data-element_type="widget" data-widget_type="image.default">
      <div class="elementor-widget-container">
    <style>/*! elementor - v3.19.0 - 29-01-2024 */
    .elementor-widget-image{text-align:center}.elementor-widget-image a{display:inline-block}.elementor-widget-image a img[src$=".svg"]{width:48px}.elementor-widget-image img{vertical-align:middle;display:inline-block}</style>											<a href="{{aap_url}}" target="_parent">
        <img loading="lazy" width="300" height="108" src="assets/images/Pink_horizontalLogo-300x108.png" class="attachment-medium size-medium wp-image-7" alt="Honest Gorilla logo in Pink with Horizontal layout."  sizes="(max-width: 300px) 100vw, 300px">								</a>
                    </div>
    </div>
    </div>
    </div>
    </div>
    </header>
      <!-- <a
        class="optn handsymbol"
        
        (click)="headerMenu('startover')"
        >Start Over
        <img src="assets/images/startover-re.svg" class="pt-1 float-right"
      /></a>
     -->
  
      <!-- <a
        class="optn handsymbol"
        *ngIf="showLogin"
        (click)="headerMenu('user-settings')"
        >Profile
        <img
          src="assets/images/profile-icon-lightgray.svg"
          class="pt-2 float-right"
      /></a> -->
  

          <!-- <a
        class="optn handsymbol"
        *ngIf="showLogin"
        (click)="headerMenu('logout')"
        >Logout
        <img
          src="assets/images/logout-icon-lightgray.svg"
          class="pt-2 float-right"
      /></a>
   -->

   
      <!-- <a  
      *ngIf="showLogin"
        (click)="headerMenu('logout')"
      class="btn sectbtn notibtn semi-bold mb-3 mt-2 ng-star-inserted"  style="float: right !important; text-transform: uppercase !important">Logout
      </a>
    
      <a  
      *ngIf="showLogin"
        (click)="headerMenu('user-settings')"
      class="btn sectbtn notibtn semi-bold mb-3 mt-2 ng-star-inserted mr-2"  style="float: right !important; text-transform: uppercase !important">Profile
      </a>
     -->


  
      

    
   
  </div>
  
  <div id="main" class="w-100" *ngIf="!IsAdminLogin && iconshow && showheader != 'true'">
  

    <!-- <a
    class="optn handsymbol"
    *ngIf="showLogin"
    (click)="headerMenu('user-settings')"
    >Profile
    <img
      src="assets/images/profile-icon-lightgray.svg"
      class="pt-2 float-right"
  /></a>

  <a
    class="optn handsymbol"
    *ngIf="showLogin"
    (click)="headerMenu('logout')"
    >Logout
    <img
      src="assets/images/logout-icon-lightgray.svg"
      class="pt-2 float-right"
  /></a> -->

 


<!--   
  <a  
  *ngIf="showLogin"
    (click)="headerMenu('logout')"
  class="btn sectbtn notibtn semi-bold mb-3 mt-1 ng-star-inserted mr-2"  style="float: right !important; text-transform: uppercase !important">Logout
  </a>


  <a  
  *ngIf="showLogin"
    (click)="headerMenu('user-settings')"
  class="btn sectbtn notibtn semi-bold mb-3 mt-1 ng-star-inserted mr-2"  style="float: right !important; text-transform: uppercase !important">Profile
  </a>
   -->

   <header class="newhearder-fixed elementor-section elementor-top-section elementor-element elementor-element-4fbb326 elementor-section-height-min-height elementor-reverse-mobile elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-items-middle elementor-sticky elementor-sticky--active elementor-section--handles-inside" data-id="4fbb326" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;sticky&quot;:&quot;top&quot;,&quot;sticky_on&quot;:[&quot;desktop&quot;],&quot;sticky_effects_offset&quot;:80,&quot;sticky_offset&quot;:0}" >
    <div class="elementor-container elementor-column-gap-no">
  <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3d93f29" data-id="3d93f29" data-element_type="column">
  <div class="elementor-widget-wrap elementor-element-populated">
    <div class="elementor-element elementor-element-2a9644b elementor-widget elementor-widget-image" data-id="2a9644b" data-element_type="widget" data-widget_type="image.default">
    <div class="elementor-widget-container">
  <style>/*! elementor - v3.19.0 - 29-01-2024 */
  .elementor-widget-image{text-align:center}.elementor-widget-image a{display:inline-block}.elementor-widget-image a img[src$=".svg"]{width:48px}.elementor-widget-image img{vertical-align:middle;display:inline-block}</style>											<a href="{{aap_url}}" target="_parent">
      <img loading="lazy" width="300" height="108" src="assets/images/Pink_horizontalLogo-300x108.png" class="attachment-medium size-medium wp-image-7" alt="Honest Gorilla logo in Pink with Horizontal layout." sizes="(max-width: 300px) 100vw, 300px">								</a>
                  </div>
  </div>
  </div>
  </div>
  </div>
  </header>

    <a *ngIf="!isPre_success"
   
    class="float-right text-center ml-1 mt-1 wd60 webview handsymbol"
    data-toggle="modal"
    data-target="#contactModal"
    (click)="showModal()"
    ><img src="assets/images/help.png" />
    <font class="disblk clr333 quesnavtxt handsymbol">Help</font>
    </a>
    <a
    *ngIf="!isPre_success"
    class="float-right text-center ml-1 mt-1 wd60 webview handsymbol startoverclass"
    (click)="startOver()"
    ><img src="assets/images/startovergry.png" />
    <font class="disblk clr333 quesnavtxt handsymbol">Start Over</font>
    </a>
  <br /><br />
  </div>
  

</div>


<!-- <a *ngIf="iconshow" class="float-right text-center ml-1 wd100 webview"  (click)="startOver()"><img
        src="assets/images/startovergry.png">
      <font class="disblk font18 clr333">Start Over</font>
    </a>
    <a *ngIf="iconshow" class="float-right text-center ml-1 wd100 webview"  data-toggle="modal" data-target="#contactModal"><img src="assets/images/help.png">
      <font class="disblk font18 clr333">Help</font>
    </a>
  </nav> -->
